import { ModelMixin, Model } from '../../../domain/model/common/model.class';

export class NotesModel extends ModelMixin() implements Model<NotesModel> {
    TYPE = NotesModel;
    note: string;
    noteDate: Date;
    id: string;
    version: string;
    userId: string;
    createdByName: string;

    constructor(jsonData: any = {}) {
        super();
        const parsedData = {
            ...jsonData,
            noteDate: new Date(jsonData.noteDate)
        };
        Object.assign(this, parsedData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/notes/model/notes.model.ts